@if (user) {
    <app-history-overview [Id]="user.guid" [historyDataService]="_historyDS" #historyComponent>
    </app-history-overview>
}
